import theme from "../../../customStyles"

export default theme
